var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u7EC4_8398",
    "data-name": "\\u7EC4 8398",
    transform: "translate(-5260 3878)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_3_\\u62F7\\u8D1D",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 3 \\u62F7\\u8D1D",
    width: 12,
    height: 16,
    rx: 2,
    transform: "translate(5264 -3877)",
    fill: "rgba(153,153,153,0.2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5706\\u89D2\\u77E9\\u5F62_3",
    "data-name": "\\u5706\\u89D2\\u77E9\\u5F62 3",
    d: "M1024,479a2,2,0,0,1-2-2V463a2,2,0,0,1,2-2h10a2,2,0,0,1,2,2v14a2,2,0,0,1-2,2Zm-1-3a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2v-2h-12Zm12-3v-9a2,2,0,0,0-2-2h-8a2,2,0,0,0-2,2v9Zm-7,3a1,1,0,1,1,1,1A1,1,0,0,1,1028,476Z",
    transform: "translate(4238 -4339)",
    fill: "#999"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/手机.092b518e94524c02c2e81c051fcc90b2.svg";
export { ForwardRef as ReactComponent };